import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeIn } from "../FadeIn";
import { MagneticButton } from "../MagneticButton";
import { PORTFOLIO } from "../../lib/images";

export const BoutiqueTeaser = () => (
  <section
    data-testid="boutique-teaser"
    className="bg-bone text-ink section-pad relative overflow-hidden"
  >
    <div className="container-x">
      <div className="grid md:grid-cols-2 gap-16 items-center">
        <FadeIn>
          <div className="eyebrow mb-3" style={{ color: "#4A4E57" }}>Boutique</div>
          <h2 className="font-display text-5xl md:text-7xl text-ink mb-6">
            Emportez la <span className="italic text-stone">montagne</span> chez vous.
          </h2>
          <p className="text-ink/70 max-w-md mb-8">
            Tirages d{"'"}art en édition limitée. Disponible bientôt.
          </p>
          <Link to="/boutique" data-testid="boutique-cta">
            <MagneticButton className="btn-line dark" as="span">
              <span>Bientôt disponible</span>
              <ArrowRight size={14} />
            </MagneticButton>
          </Link>
        </FadeIn>
        <FadeIn delay={0.2}>
          <div className="grid grid-cols-3 gap-3">
            {PORTFOLIO.slice(8, 11).map((p, i) => (
              <div
                key={p.id}
                className={`overflow-hidden ${i === 1 ? "translate-y-8" : ""}`}
              >
                <img
                  src={p.src}
                  alt={p.title}
                  className="w-full h-[280px] object-cover"
                />
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </div>
  </section>
);
